var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"18.501","cy":"18.5","r":"17.5","fill":"#FFB699","stroke":"#FF5600","strokeWidth":"2","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20.2956 7.00035L29.5099 17.6695L30.2627 18.5412L29.5099 19.4129L20.2956 30.082L18.2769 28.3386L25.5867 19.8747H7.00098V17.2075H25.5865L18.2769 8.74374L20.2956 7.00035Z","fill":"#FF5600","key":1})]);
}

ArrowRight.defaultProps = {"width":"37","height":"37","viewBox":"0 0 37 37","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
